import { useTranslation } from 'react-i18next';

import { GPT_BANNER_CONFIG } from '../config';

import { GPTBannerProps } from 'src/EXPERIMENTAL_LIB/modules/gpt/banners';
import { CrossIcon } from './CrossIcon';

export const GPTBanner = ({ Icon, title, onClick, onClose, gameName }: GPTBannerProps) => {
  const { background, boxShadow, textShadow } = GPT_BANNER_CONFIG[gameName] || {};
  const { t } = useTranslation();

  return (
    <div className="relative w-[200px] 1024:w-[267px] h-[44px] 1024:h-[58px] pl-3 1024:pl-[17px] select-none cursor-pointer">
      {Icon && (
        <Icon
          onClick={onClick}
          className="absolute top-1/2 -translate-y-1/2 left-0 w-10 h-10 1024:h-[52px] 1024:w-[52px] z-10"
        />
      )}
      <div
        onClick={onClick}
        className="w-full h-full rounded pl-9 pr-1 py-1 1024:pl-12 1024:pr-2 flex justify-between items-center gap-2"
        style={{ background, boxShadow }}>
        <p
          className="line-clamp-2 text-gb_spin_and_win_text text-base 1024:text-2xl leading-4 1024:leading-[26px] font-semibold flex-grow text-start break-words 768:max-w-[160px] max-w-[106px]"
          style={{ textShadow }}>
          {title && t(title)}
        </p>
        <button onClick={onClose}>
          <CrossIcon />
        </button>
      </div>
    </div>
  );
};
